import { getColor } from '../UICommon';
import { InputColorVariant } from './InputField.types';

export const getInputFieldBackgroundColor = (variant: InputColorVariant) =>
  ({
    [InputColorVariant.White]: getColor('WHITE'),
  }[variant]);
